import { FetchResponseError } from './FetchResponseError'

/** Throw une FetchResponseError si statut !== 200 */
export function ensureSuccessStatusCode(response: Response): void {
  if (response.ok) return
  throw new FetchResponseError(response)
}
